export default "__VITE_ASSET__93702201__"